import { createApiClient } from '@rudi/api/client';
import { cortexAdapter } from './adapter';

/** Singleton Axios client for the Cortex app (auth + refresh interceptors installed). */
export const apiClient = createApiClient(cortexAdapter);
